// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__klbby","title":"Header_title__za29S","left":"Header_left__2vkVj","clinicName":"Header_clinicName__3BQ2q"};